import { Button, Col, Label, Row, Spinner } from "reactstrap";
import { H3 } from "../../../../AbstractElements";
import TextField from "../../../common/TextField";
import { useEffect, useState } from "react";
import Dropdown from "../../../common/DropDown";
import { useGetRequestQuery } from "../../../../Hooks/useGetRequestQuery";
import { getAllAreas, GetAllproperties, getAllStates } from "../../../../Services/MMPClientServices/PropertySearchService";
import property from '../../MMPClient/PropertySearch/property.json';
import DropdownWithValueName from "../../../common/DropdownWithValueName";
import BootstrapTable from "react-bootstrap-table-next";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { PackageDownload, PropertyFlyer, StateReport } from "../../CRMAdmin/CRMPropertySearch/PropertyFlyer";
import { toast } from "react-toastify";
import autoTable from "jspdf-autotable";

export default function PropertySearch() {
    const [propertiesData, setPropertiesData] = useState<any>([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [searchTrigger, setSearchTrigger] = useState(0);
    const [statesData, setStatesData] = useState<any>([]);
    const [suburb, setSuburb] = useState<any[]>([]);
    const [areasData, setAreasData] = useState([]);
    const [selectedFlyer, setSelectedFlyer] = useState<any>({})
    const [loading, setLoading] = useState(false);
    const [selectedPackage, setSelectedPackage] = useState<any>({})
    // const BASE_URL = `${process.env.REACT_APP_API_BASE_URL}/PropertyImages/`;

    const [formData, setFormData] = useState({
        propertyId: '',
        state: '',
        yield: '',
        minimumBed: '',
        maxPrice: '',
        area: '',
        titled: '',
        contractType: '',
        propType: '',
        suburb: '',
        landSize: '',
    });

    const handleValueChange = (name: string, value: string | number) => {
        setFormData({ ...formData, [name]: value });
    };

    const selectedArea: any = areasData.filter((area: any) => area.value == formData.area);
    const selectedSuburb: any = suburb.filter((area: any) => area.value == formData.suburb);

    const params = {
        PageNumber: 0,
        PageSize: 0,
        Area: selectedArea[0]?.value,
        // clientId : userData?.nameidentifier,
        PropertyType: formData.propType,
        Bedrooms: formData.minimumBed,
        Price: formData.maxPrice,
        MaximumPrice: formData.maxPrice,
        Suburb: selectedSuburb[0]?.value,
        SearchedLandSQM: formData.landSize,
        ContractType: formData.contractType,
        Title: formData.titled,
        PropertyId: formData.propertyId,
        Supplier: "",
        stateid: formData.state,
        PropertyName: ""
    };

    const {
        data: allPropertiesData,
        isLoading: allPropertiesLoading,
        isError: allPropertiesIsError,
        refetch
    } = useGetRequestQuery(
        ["getAllProperties", currentPage, pageSize, searchTrigger],
        () => GetAllproperties(params as any),
        {
            enabled: true,
        }
    );

    useEffect(() => {
        if (allPropertiesData?.data && !allPropertiesIsError && !allPropertiesLoading) {
            setPropertiesData(allPropertiesData?.data);
        }
    }, [allPropertiesData, allPropertiesIsError, allPropertiesLoading]);


    const {
        data: allStatesData,
        isLoading: allStatesLoading,
        isError: allStatesIsError,
    } = useGetRequestQuery(
        ["getAllStates"],
        getAllStates,
        {
            enabled: true,
        }
    );

    useEffect(() => {
        if (allStatesData?.data && !allStatesIsError && !allStatesLoading) {
            const transformedData = allStatesData.data.map((state: any) => ({
                value: state.id,
                label: state.name
            }));
            setStatesData(transformedData);
        }
    }, [allStatesData, allStatesIsError, allStatesLoading]);

    const {
        data: allAreasData,
        isLoading: allAreasLoading,
        isError: allAreasIsError,
    } = useGetRequestQuery(
        ["getAllAreas", formData.state],
        () => getAllAreas({
            searchId: formData.state,
            searchType: "area"
        }),
        {
            enabled: !!formData.state,
        }
    );

    useEffect(() => {
        if (allAreasData?.data && !allAreasIsError && !allAreasLoading) {
            const transformedData = allAreasData?.data?.map((area: any) => ({
                value: area.id,
                label: area.name
            }));
            setAreasData(transformedData);
        }
    }, [allAreasData, allAreasIsError, allAreasLoading]);


    const {
        data: allSuburbsData,
        isLoading: allSuburbsLoading,
        isError: allSuburbsIsError,
    } = useGetRequestQuery(
        ["getAllSuburbs", formData.area],
        () => getAllAreas({
            searchId: formData.area,
            searchType: "suburb"
        }),
        {
            enabled: !!formData.area,
        }
    );

    useEffect(() => {
        if (allSuburbsData?.data && !allSuburbsIsError && !allSuburbsLoading) {
            const transformedSuburbsData = allSuburbsData?.data?.map((suburb: any) => ({
                value: suburb.id,
                label: suburb.name,
            }));
            setSuburb(transformedSuburbsData);
        }
    }, [allSuburbsData, allSuburbsIsError, allSuburbsLoading]);

    const handleSearch = () => {
        setSearchTrigger((prev) => prev + 1);
    };

    const exportToPDF = () => {
        const pdf = new jsPDF({ orientation: "landscape" });
        const logo = new Image();
        logo.src = "/assets/images/fintrack_logo.png";

        logo.onload = () => {
            const margin = 10;
            const logoWidth = 60;
            const logoHeight = 15;

            const logoX = margin;
            const logoY = margin;

            pdf.addImage(logo, "PNG", logoX, logoY, logoWidth, logoHeight);

            const options: Intl.DateTimeFormatOptions = { day: "numeric", month: "long", year: "numeric" };
            const currentDate = new Date().toLocaleDateString("en-GB", options);

            pdf.setFontSize(12);
            pdf.setTextColor(0, 0, 0);

            const dateText = `Date: ${currentDate}`;
            const dateX = pdf.internal.pageSize.width - margin - pdf.getTextWidth(dateText);
            const dateY = logoY + (logoHeight / 2) + 4;
            pdf.text(dateText, dateX, dateY);

            const lineY = logoY + logoHeight + 10;
            pdf.setDrawColor(0, 0, 255);
            pdf.line(margin, lineY, pdf.internal.pageSize.width - margin, lineY);

            const mapStateIdToLabel = (stateId: any) => {
                const state = statesData.find((s: any) => s.value === stateId);
                return state ? state.label : "N/A";
            };

            const excelData = propertiesData.map((row: any) => [
                row.propertyId,
                row.lotNumber,
                row.estate,
                row.propertyAddress,
                row.suburb,
                mapStateIdToLabel(row.stateId),
                row.areaName,
                row.price1Bedroom,
                row.rentYield,
                row.bedrooms,
                row.landSize,
                row.titled
            ]);

            const headers = [
                ["ID", "Lot #", "Estate", "Address", "Suburb", "State", "Area", "Price", "Yield", "Beds", "Land", "Titled"]
            ];

            autoTable(pdf, {
                head: headers,
                body: excelData,
                startY: lineY + 5,
                margin: { left: margin, right: margin },
                styles: { cellPadding: 2, lineWidth: 0 },
                headStyles: { fillColor: [0, 0, 255], textColor: 255 },
            });

            pdf.save("properties_data.pdf");
        };

        logo.onerror = () => {
            console.error("Error loading the logo image.");
        };
    };

    useEffect(() => {
        if (selectedFlyer && Object.keys(selectedFlyer).length > 0) {
            generatePDF();
        }
    }, [selectedFlyer]);

    const generatePDF = async () => {
        if (!selectedFlyer) return;

        try {
            const htmlContent = await PropertyFlyer(selectedFlyer);

            // Create an off-screen container
            const hiddenElement = document.createElement("div");
            hiddenElement.style.width = "800px";
            hiddenElement.style.padding = "20px";
            hiddenElement.style.backgroundColor = "white";
            hiddenElement.style.fontFamily = "Arial, sans-serif";
            hiddenElement.style.position = "absolute";
            hiddenElement.style.left = "-9999px";
            hiddenElement.innerHTML = htmlContent;

            document.body.appendChild(hiddenElement);

            const canvas = await html2canvas(hiddenElement, {
                scale: 2,
                useCORS: true,
                allowTaint: true,
                logging: true,
                imageTimeout: 15000
            });

            const imgData = canvas.toDataURL("image/png");

            const pdf = new jsPDF("p", "mm", "a4");
            const imgWidth = 210;
            const imgHeight = (canvas.height * imgWidth) / canvas.width;

            pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);
            pdf.save(`property-details-${selectedFlyer.propertyId}.pdf`);

            document.body.removeChild(hiddenElement);
        } catch (error) {
            console.error('Error generating PDF:', error);
            // You might want to show an error message to the user here
        }
    };

    useEffect(() => {
        if (selectedPackage && Object.keys(selectedPackage).length > 0) {
            generatePackagePDF();
        }
    }, [selectedPackage]);

    const generatePackagePDF = async () => {
        setLoading(true);
        const pdf = new jsPDF("p", "mm", "a4");
        const imgWidth = 210;

        const addHtmlToPdf = async (htmlContent: any, isFirstPage = false) => {
            const hiddenElement = document.createElement("div");
            hiddenElement.style.width = "800px";
            hiddenElement.style.padding = "20px";
            hiddenElement.style.backgroundColor = "white";
            hiddenElement.style.fontFamily = "Arial, sans-serif";
            hiddenElement.style.position = "absolute";
            hiddenElement.style.left = "-9999px";
            hiddenElement.innerHTML = htmlContent;

            document.body.appendChild(hiddenElement);

            const canvas = await html2canvas(hiddenElement, {
                scale: 2,
                useCORS: true,
                allowTaint: true
            });

            const imgData = canvas.toDataURL("image/png");
            const imgHeight = (canvas.height * imgWidth) / canvas.width;

            if (!isFirstPage) pdf.addPage();
            pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);

            document.body.removeChild(hiddenElement);
        };

        await addHtmlToPdf(PackageDownload(selectedPackage), true);
        await addHtmlToPdf(StateReport());

        // Convert PDF to Blob
        const pdfBlob = pdf.output("blob");
        const pdfUrl = URL.createObjectURL(pdfBlob);

        // Open in new tab
        setLoading(false);
        window.open(pdfUrl, "_blank");
    };
    useEffect(() => {
        if (loading) {
            toast.info("Generating PDF, please wait...", {
                autoClose: 2000,
                closeButton: true,
            });
        }
    }, [loading]);

    const propertyColumns = [
        { dataField: "propertyId", text: "ID", headerStyle: { width: "2rem", color: "#0000ff" } },
        { dataField: "propertyAddress", text: "Address", headerStyle: { width: "20rem", color: "#0000ff" } },
        { dataField: "estate", text: "Estate", headerStyle: { color: "#0000ff" } },
        { dataField: "suburb", text: "Suburb", headerStyle: { color: "#0000ff" } },
        {
            dataField: "price1Bedroom",
            text: "Price",
            formatter: (cell: any) => (cell ? `$${cell}` : "$0"),
            headerStyle: { width: "10rem", color: "#0000ff" },
        },
        {
            dataField: "rentYield",
            text: "Yield",
            headerStyle: { width: "7rem", color: "#0000ff" },
            formatter: (cell: any) => `${cell} ${cell ? "%" : ''}`
        },
        { dataField: "bedrooms", text: "Beds", headerStyle: { width: "5rem", color: "#0000ff" } },
        {
            dataField: "landPrice",
            text: "Land",
            formatter: (cell: any) => (cell ? `$${cell}` : "$0"),
            headerStyle: { width: "7rem", color: "#0000ff" },
        },
        { dataField: "titled", text: "Titled", headerStyle: { width: "5rem", color: "#0000ff" } },
        {
            dataField: "actions",
            text: (
                <>
                    <span>Action</span>
                </>
            ),
            formatter: (_: any, row: any) => {
                const allImagesUploaded = row.subdivisionImage &&
                    row.builderFaçadePageimage &&
                    row.floorPlanimage &&
                    row.inclusionsimage &&
                    row.estateimage;
                return (
                    <ul className="action simple-list d-flex flex-row align-items-center">
                        <li
                            style={{ cursor: "pointer", marginLeft: '10px' }}
                            onClick={() => { setSelectedFlyer(row) }}
                            className="edit"
                        >
                            <a className="primary">Flyer</a>
                        </li>
                        <span style={{ color: 'blue' }}> |</span>
                        <>
                            {allImagesUploaded && (
                                <>
                                    <li
                                        style={{ cursor: "pointer", marginLeft: '10px', marginRight: '10px' }}
                                        className="delete"
                                    >
                                        <span className="primary" style={{ color: 'var(--theme-default)' }} onClick={() => setSelectedPackage(row)}>
                                            Package
                                        </span>
                                    </li>
                                    <span style={{ color: 'blue' }}> |</span>
                                </>
                            )}
                            {allImagesUploaded ? (
                                <li style={{ marginLeft: "10px", display: "flex", alignItems: "center" }}>
                                    <label htmlFor={`yes-${row.propertyId}`} style={{ color: "green", fontWeight: "bold" }}>Yes</label>
                                </li>
                            ) : (
                                <li style={{ marginLeft: "10px", display: "flex", alignItems: "center" }}>
                                    <label htmlFor={`no-${row.propertyId}`} style={{ color: "red", fontWeight: "bold" }}>No</label>
                                </li>
                            )}
                        </>
                    </ul>
                )
            },
            headerStyle: { width: "20rem", color: "#0000ff" },
        }
    ];
    return (
        <>
            <div className='container-fluid'>
                <div className="table-responsive h-100 py-4">
                    <section className='bg-white'>
                        <div className="scrollable-table-container">
                            <table className="scrollable-table" style={{ marginLeft: '1%', marginTop: '3%' }}>
                                <div className="d-flex align-items-center">
                                    <Col xs={12} className='d-flex'>
                                        <H3 className="heading-color f-w-900 text-left">Property Search</H3>
                                    </Col>
                                </div>


                                <Row className='mt-4'>
                                    <div className='d-flex item-center mt-2'>
                                        <Col className="responsive-col" xs={12} style={{ width: '7%', paddingInline: '2px' }}>
                                            <Label className="mb-3">Property ID:</Label>
                                        </Col>
                                        <Col className="responsive-col" xs={12} style={{ width: '14%', paddingInline: '2px' }}>
                                            <TextField
                                                label=""
                                                type="text"
                                                name="propertyId"
                                                value={formData.propertyId}
                                                setValue={handleValueChange}
                                                placeholder=""
                                                design="flex"
                                                passCol='col-10'
                                                maxChars={6}
                                                tabIndex={1}
                                            />
                                        </Col>
                                        <Col className="responsive-col" xs={12} style={{ width: '5%', paddingInline: '2px' }}>
                                            <Label className="mb-3">State:</Label>
                                        </Col>
                                        <Col className="responsive-col" xs={12} style={{ width: '14%', paddingInline: '2px' }}>
                                            <DropdownWithValueName
                                                label=""
                                                name="state"
                                                value={formData.state}
                                                setValue={handleValueChange}
                                                options={statesData || []}
                                                required={true}
                                                tabIndex={5}
                                                passCol="col-10"
                                            />
                                        </Col>
                                        <Col className="responsive-col" xs={12} style={{ width: '8%', paddingInline: '2px' }}>
                                            <Label className="mb-3">Highest Yield:</Label>
                                        </Col>
                                        <Col className="responsive-col" xs={12} style={{ width: '14%', paddingInline: '2px' }}>
                                            <Dropdown
                                                label=""
                                                name="yield"
                                                value={formData.yield}
                                                setValue={handleValueChange}
                                                options={property.yield}
                                                required={true}
                                                tabIndex={5}
                                                passCol="col-10"
                                            />
                                        </Col>
                                        <Col className="responsive-col" xs={12} style={{ width: '8%', paddingInline: '2px' }}>
                                            <Label className="mb-3">Minimum Bed:</Label>
                                        </Col>
                                        <Col className="responsive-col" xs={12} style={{ width: '14%', paddingInline: '2px' }}>
                                            <DropdownWithValueName
                                                label=""
                                                name="minimumBed"
                                                value={formData.minimumBed}
                                                setValue={handleValueChange}
                                                options={property.minimumBed}
                                                required={true}
                                                tabIndex={5}
                                                passCol="col-10"
                                            />
                                        </Col>
                                        <Button onClick={handleSearch} size="sm" style={{ marginBottom: '16px', fontSize: '16px', width: '10%' }} className="text-center" color="success" >
                                            Search Now
                                        </Button>
                                    </div>
                                    <div className="d-flex align-items-center">
                                        <Col className="responsive-col" xs={12} style={{ width: '7%', paddingInline: '2px' }}>
                                            <Label className="mb-3">Max Price:</Label>
                                        </Col>
                                        <Col className="responsive-col" xs={12} style={{ width: '14%', paddingInline: '2px' }}>
                                            <DropdownWithValueName
                                                label=""
                                                name="maxPrice"
                                                value={formData.maxPrice}
                                                setValue={handleValueChange}
                                                options={property.maxPrice}
                                                tabIndex={1}
                                                passCol="col-10"
                                            />
                                        </Col>
                                        <Col className="responsive-col" xs={12} style={{ width: '5%', paddingInline: '2px' }}>
                                            <Label className="mb-3">Area:</Label>
                                        </Col>
                                        <Col className="responsive-col" xs={12} style={{ width: '14%', paddingInline: '2px' }}>
                                            <DropdownWithValueName
                                                label=""
                                                name="area"
                                                value={formData.area}
                                                setValue={handleValueChange}
                                                options={areasData || []}
                                                tabIndex={2}
                                                passCol="col-10"
                                            />
                                        </Col>
                                        <Col className="responsive-col" xs={12} style={{ width: '8%', paddingInline: '2px' }}>
                                            <Label className="mb-3">Titled:</Label>
                                        </Col>
                                        <Col className="responsive-col" xs={12} style={{ width: '14%', paddingInline: '2px' }}>
                                            <Dropdown
                                                label=""
                                                name="titled"
                                                value={formData.titled}
                                                setValue={handleValueChange}
                                                options={property.titled}
                                                tabIndex={3}
                                                passCol="col-10"
                                            />
                                        </Col>
                                        <Col className="responsive-col" xs={12} style={{ width: '8%', paddingInline: '2px' }}>
                                            <Label className="mb-3">Contract Type:</Label>
                                        </Col>
                                        <Col className="responsive-col" xs={12} style={{ width: '14%', paddingInline: '2px' }}>
                                            <DropdownWithValueName
                                                label=""
                                                name="contractType"
                                                value={formData.contractType}
                                                setValue={handleValueChange}
                                                options={property.contractType}
                                                tabIndex={4}
                                                passCol="col-10"
                                            />
                                        </Col>
                                        <Button
                                            color="primary"
                                            size="sm"
                                            onClick={exportToPDF}
                                            disabled={propertiesData.length === 0}
                                            style={{ marginBottom: '14px', fontSize: '16px', width: '10%' }}
                                        >
                                            Property List
                                        </Button>
                                    </div>

                                    {/* Third Row */}
                                    <div className="d-flex align-items-center">
                                        <Col className="responsive-col" xs={12} style={{ width: '7%', paddingInline: '2px' }}>
                                            <Label className="mb-3">Prop Type:</Label>
                                        </Col>
                                        <Col className="responsive-col" xs={12} style={{ width: '14%', paddingInline: '2px' }}>
                                            <Dropdown
                                                label=""
                                                name="propType"
                                                value={formData.propType}
                                                setValue={handleValueChange}
                                                options={property.propType}
                                                tabIndex={5}
                                                passCol="col-10"
                                            />
                                        </Col>
                                        <Col className="responsive-col" xs={12} style={{ width: '5%', paddingInline: '2px' }}>
                                            <Label className="mb-3">Suburb:</Label>
                                        </Col>
                                        <Col className="responsive-col" xs={12} style={{ width: '14%', paddingInline: '2px' }}>
                                            <DropdownWithValueName
                                                label=""
                                                name="suburb"
                                                value={formData.suburb}
                                                setValue={handleValueChange}
                                                options={suburb}
                                                tabIndex={6}
                                                passCol="col-10"
                                            />
                                        </Col>
                                        <Col className="responsive-col" xs={12} style={{ width: '8%', paddingInline: '2px' }}>
                                            <Label className="mb-3">Land Size:</Label>
                                        </Col>
                                        <Col className="responsive-col" xs={12} style={{ width: '14%', paddingInline: '2px' }}>
                                            <DropdownWithValueName
                                                label=""
                                                name="landSize"
                                                value={formData.landSize}
                                                setValue={handleValueChange}
                                                options={property.landSize}
                                                tabIndex={7}
                                                passCol="col-10"
                                            />
                                        </Col>
                                        <Col className="responsive-col" xs={12} style={{ width: '8%', paddingInline: '2px' }}>
                                        </Col>
                                        <Col className="responsive-col" xs={12} style={{ width: '14%', paddingInline: '2px' }}>

                                        </Col>
                                    </div>
                                </Row>
                            </table>
                        </div>
                    </section>
                </div>
                {allPropertiesLoading ? (
                    <div
                        style={{
                            borderRadius: "8px",
                            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                            padding: "12px",
                            backgroundColor: "#fff",
                            textAlign: "center",
                        }}
                        className="mt-4 mb-2"
                    >
                        <Spinner color="primary" />
                    </div>
                ) : propertiesData.length !== 0 ? (
                    <div
                        style={{
                            borderRadius: "8px",
                            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                            padding: "5px",
                            backgroundColor: "#fff",
                            overflowX: "auto",
                            width: "100%",
                        }}
                        className="mb-4"
                    >
                        <div style={{ minWidth: "max-content" }}>
                            <BootstrapTable
                                keyField="propertyId"
                                data={propertiesData}
                                columns={propertyColumns as any}
                                bordered={false}
                                wrapperClasses="table-responsive"
                            />
                        </div>
                    </div>
                ) : (
                    <div
                        style={{
                            borderRadius: "8px",
                            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                            padding: "12px",
                            backgroundColor: "#fff",
                            textAlign: "center",
                        }}
                        className="mt-4 mb-2"
                    >
                        <h6>No properties data available.</h6>
                    </div>
                )}
            </div>
        </>
    );
}